/**
 * Every variable need to have suffix 'Var' and should have description above
 */
// export const exampleNameVar = makeVar<boolean>(false);

export const resetVars = () => {};
